<script setup lang="ts">
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    type?: "button" | "submit" | "reset"
    variant?: "primary" | "secondary" | "ghost" | "danger"
    size?: "sm" | "md" | "lg"
    disabled?: boolean
    fullWidth?: boolean
  }>(),
  {
    type: "button",
    variant: "primary",
    size: "md",
    disabled: false,
    fullWidth: false,
  }
)

const variantClass = computed(() => {
  return {
    primary: "bg-slate-900 text-white hover:bg-slate-800",
    secondary: "bg-white text-slate-700 border border-slate-300 hover:bg-slate-100",
    ghost: "bg-transparent text-slate-700 hover:bg-slate-100",
    danger: "bg-red-600 text-white hover:bg-red-500",
  }[props.variant]
})

const sizeClass = computed(() => {
  return {
    sm: "px-3 py-1.5 text-xs",
    md: "px-4 py-2 text-sm",
    lg: "px-5 py-2.5 text-sm",
  }[props.size]
})
</script>

<template>
  <button
    :type="type"
    :disabled="disabled"
    class="rounded-md font-medium transition disabled:cursor-not-allowed disabled:opacity-60"
    :class="[variantClass, sizeClass, fullWidth ? 'w-full' : '']"
  >
    <slot />
  </button>
</template>

